import * as Website from '../../Config/Website.js';
import LightBox from './modules/LightBox.js';


const preinit = () => {

}

const init = () => {
  LightBox();
}

const resize = () => {
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
